// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBQuuE-C_0RoylZYFphrC0xgj0PWG2XUeA",
  authDomain: "ascendancedev-d49cb.firebaseapp.com",
  projectId: "ascendancedev-d49cb",
  storageBucket: "ascendancedev-d49cb.appspot.com",
  messagingSenderId: "602811261553",
  appId: "1:602811261553:web:59631fcc3cc5f8db71f1d0",
  measurementId: "G-MT18FJDE0S"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default app  